import { Box, Button, Grid, Paper, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";
import { theme } from "../styles/theme";
import CloseModalButton from "./CloseModalButton";

export default function BandDetail({ selectedBand, handleBandDetailClosed }) {
  return (
    <Paper variant="locations-wrapper">
      <Box sx={bandDetailStyles(selectedBand)}>
        <CloseModalButton
          type="point-details"
          handleToggle={handleBandDetailClosed}
        />
        <Box className="gradient" />
        <Grid
          container
          justifyContent="center"
          sx={{ zIndex: "500", position: "relative", gap: "0.5rem" }}
        >
          <Grid item xs={12}>
            <Typography variant="h5" className="location-name">
              {selectedBand.name}
            </Typography>
          </Grid>
          <Grid item xs="auto">
            <Typography className="type">{selectedBand.type}</Typography>
          </Grid>
        </Grid>
      </Box>
      <Paper variant="map-location-description">
        <Box>
          <Grid item xs={12} textAlign="center">
            <Typography variant="body1" className="title">
              Musikgenre(s)
            </Typography>
            <Typography variant="body1" className="value" sx={{ mb: 1 }}>
              {selectedBand.genre}
            </Typography>
          </Grid>
          <Grid item xs={12} align="center" sx={{ mt: 4 }}>
            <Button
              component="a"
              target="_blank"
              rel="noopener"
              href={selectedBand.website}
              fullWidth
              variant="outlined"
              color="secondary"
              className="website-link"
            >
              Zur Website
            </Button>
          </Grid>
          ´{" "}
        </Box>
      </Paper>
    </Paper>
  );
}

const bandDetailStyles = (selectedBand) => {
  return {
    background: `linear-gradient(0deg, ${grey[900]} 0%, ${grey[800]} 100%)`,
    padding: "2rem",
    position: "relative",
    "& .location-name": {
      color: "#fff !important",
      textAlign: "center",
    },
    "& .gradient": {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      opacity: 0.25,
    },
    "& .type": {
      textTransform: "capitalize",
      textAlign: "center",
      color: theme.palette.common.white,
      padding: "0 0.5rem",
      marginTop: "0.25rem",
      borderRadius: "0.25rem",
      backgroundColor:
        selectedBand.type === "solo" ? "#DD0078" : theme.palette.primary.main,
      "&::after": {
        content: "''",
        bottom: "-2rem",
        left: "0",
        width: "100%",
        height: "1px",
        position: "absolute",
        background:
          selectedBand.type === "solo" ? "#DD0078" : theme.palette.primary.main,
      },
    },
  };
};
